import {v4 as uuidv4} from "uuid";
import {TimeInterval} from '@/types/time-interval';
import {CameraToTicketCategoryClass} from '@/types/CameraToTicketCategoryClass';

export class TicketCategory {
  constructor(
    public event: string = '',
    public title: string = 'Новая категория',
    public id: string = uuidv4(),
    // дополнительные ограничения по времени
    public exTs: string = '',
    // дополнительные ограничения по камерам
    public exCam: string = '',
    public ticketCount: number | null = 0,
    public timeIntervals: TimeInterval[] = [],
    public useCustomConfig = false,
    public cameraToTicketCategory: CameraToTicketCategoryClass[] = [],
  ) {
  }
}
